import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

function loadScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

// Opens Razorpay for a franchise-module order; resolves with backend status ("paid" | "processing") or null.
export async function payFranchiseOrder(order, { description, prefill = {} }) {
  if (!(await loadScript()) || !window.Razorpay) { toast.error("Could not load payment gateway"); return null; }
  return new Promise((resolve) => {
    const rzp = new window.Razorpay({
      key: order.key_id, amount: order.amount, currency: order.currency, order_id: order.razorpay_order_id,
      name: "VIRIKS", description, prefill, theme: { color: "#ED1C24" },
      handler: async (resp) => {
        try {
          const { data } = await api.post("/franchise/payments/verify", resp);
          resolve(data.status);
        } catch (e) {
          toast.error(formatApiError(e.response?.data?.detail) || "Payment verification failed");
          resolve(null);
        }
      },
      modal: { ondismiss: () => resolve(null) },
    });
    rzp.on("payment.failed", () => toast.error("Payment failed. Please try again."));
    rzp.open();
  });
}

export const track = (event, meta) => { api.post("/franchise/track", { event, meta }).catch(() => {}); };

// Opens Razorpay subscription checkout (auto-debit mandate); resolves with verify response or null.
export async function payEducatorSubscription(sub, prefill = {}) {
  if (!(await loadScript()) || !window.Razorpay) { toast.error("Could not load payment gateway"); return null; }
  return new Promise((resolve) => {
    const rzp = new window.Razorpay({
      key: sub.key_id, subscription_id: sub.subscription_id, name: "VIRIKS", description: "Educator Plan — monthly",
      prefill, theme: { color: "#ED1C24" },
      handler: async (resp) => {
        try { const { data } = await api.post("/educator/subscription/verify", resp); resolve(data); }
        catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Verification failed"); resolve(null); }
      },
      modal: { ondismiss: () => resolve(null) },
    });
    rzp.on("payment.failed", () => toast.error("Payment failed. Please try again."));
    rzp.open();
  });
}
